import { OrderPagePrice } from '../../OrderPageSettingsPage';
import { PartialLabelData } from '../../../api';

/** What the booking slider counts unless the business counts something else (projects, rooms...). */
export const DEFAULT_PRICE_UNIT_LABEL: PartialLabelData = { en: 'participant', he: 'משתתף' };

export const isBasePricing = (price: OrderPagePrice): boolean => {
  return !price.custom_per_unit_pricing?.length;
};

export const isPersonsNumberPrice = (price: OrderPagePrice): boolean => {
  return price.type === 'number' && price.data_type === 'persons';
};

export const isCustomUnitPricing = (price: OrderPagePrice): boolean => {
  return !!price.custom_per_unit_pricing?.length;
};
